'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const clsx = require('clsx');
const React = require('react');
const reactAriaComponents = require('react-aria-components');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_1up1u_1";
const checkbox = "_checkbox_1up1u_13";
const label = "_label_1up1u_53";
const styles = {
	root: root,
	checkbox: checkbox,
	label: label
};

const Checkbox = (_a) => {
  var { children, className, validationBehavior = "native" } = _a, props = tslib_es6.__rest(_a, ["children", "className", "validationBehavior"]);
  return React__default.default.createElement(reactAriaComponents.Checkbox, Object.assign({ className: clsx.clsx(className, styles.root), "data-zds": true, validationBehavior, "data-has-no-visible-label": React__default.default.Children.count(children) === 0 ? true : void 0 }, props), ({ isIndeterminate, isSelected }) => React__default.default.createElement(
    React__default.default.Fragment,
    null,
    React__default.default.createElement(
      "div",
      { className: styles.checkbox, "data-zds": true },
      React__default.default.createElement("svg", { viewBox: "0 0 18 18", "aria-hidden": "true", "data-zds": true }, isIndeterminate ? React__default.default.createElement("rect", { x: 0, y: 7, width: 18, height: 4 }) : isSelected && React__default.default.createElement("polyline", { points: "2 9 8 14 16 4" }))
    ),
    React__default.default.createElement("div", { className: styles.label }, children)
  ));
};

exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.cjs.js.map
